import { createAction } from '@reduxjs/toolkit';

export const REMOVE_DRAWER_ORDER = 'REMOVE_DRAWER_ORDER';

export const removeDrawerOrder = createAction(
    REMOVE_DRAWER_ORDER,
    () => ({ payload: [] }),
);
